import React, { FC, PropsWithChildren } from 'react'
import styles from './formElements.module.scss'
import classNames from 'classnames'

type FormRadioProps = {
  checked?: boolean
  name: string
  onClick?: () => void
  readOnly?: boolean
  size?: 'small' | 'large'
  text?: string
  value?: string | number
}

const FormRadio: FC<PropsWithChildren<FormRadioProps>> = (props) => {
  const { children, checked, name, size = 'small', onClick, readOnly, text, value } = props
  return (
    <label
      className={classNames(styles.radio, {
        [styles.radioLarge]: size === 'large',
      })}
      data-readonly={!!readOnly}
      data-type='radio'
    >
      <input
        aria-checked={!!checked}
        checked={!!checked}
        name={name}
        onChange={() => {} /* React Warning - when no Function */}
        onClick={onClick}
        value={value}
        readOnly={!!readOnly}
        type='radio'
      />

      <span className={styles.icon} aria-hidden='true'>
        {checked && <span className={styles.checkMark} data-checked={!!checked} />}
      </span>

      {text && <p className='defaultTypographySmall'>{text}</p>}

      {children || ''}
    </label>
  )
}

export default FormRadio
